import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const ContentChatBot = ({ children }) => {
  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  });

  return (
    <div className="content" ref={ref}>
      {children}
    </div>
  );
};

ContentChatBot.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ContentChatBot;
